import angular from "angular";

angular.module("app")
.factory('UpdateService', ['$injector', '$http', '$interval', '$rootScope', 'logService', function ($injector, $http, $interval, $rootScope, logService) {

    var service = {

        version: null,
        onUpdateAvailable: null,
        autoCheck: function (seconds) {
            service.check();
            $interval(function () {
                service.check();
            }, seconds * 1000);
        },
        check: function(){
            var url = (window as any).CONFIG.api_url + '/update/check';
            $http.get(url).then(
                function(response){
                    service.version = response.data;
                    $rootScope.version = service.version;
                    if(service.onUpdateAvailable!=null) service.onUpdateAvailable(service.version);
                },
                function(err){
                    logService.error(err);
                }
            );
        },
        update: function () {
            var url = (window as any).CONFIG.api_url + '/update/update';
            $http.get(url).then(
                function (response) {
                    logService.debug(response);
                    service.version = null;
                    $rootScope.version = service.version;
                    if (service.onUpdateAvailable != null) service.onUpdateAvailable(service.version);
                    alert("Actualización aplicada");
                    location.replace(window.location.origin + window.location.pathname);
                },
                function (err) {
                    logService.error(err);
                }
            );
        },
        getInstalledVersion: function () {
            var url = (window as any).CONFIG.api_url + '/update/actualversion';
            return $http.get(url);
        },
        download: function () {
            var url = (window as any).CONFIG.api_url + '/update/download';
            window.open(url);
        }
    };

    return service;
}]);